import { render } from "./HistorialTraspasos.vue?vue&type=template&id=282b2bcf&scoped=true"
import script from "./HistorialTraspasos.vue?vue&type=script&lang=js"
export * from "./HistorialTraspasos.vue?vue&type=script&lang=js"

import "./HistorialTraspasos.vue?vue&type=style&index=0&id=282b2bcf&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\rotcen_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282b2bcf"]])

export default __exports__